import { useAppSelector } from '@/store/hooks';
import { selectUserChannel } from '@/store/slices/user/selectors';
import EmptyCastCrewShell from './empty-cast-crew-shell';
import { selectFirstSessionUuid } from '@/store/slices/project/selectors';
import useSpeakersForSession from '@/utils/speakers/use-speakers-for-session';
import { selectIsLoadingSpeakers } from '@/store/slices/speakers/selectors';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import { useCastAndCrewContext } from '../cast-and-crew-context/use-cast-and-crew-context';
import { isWebinarChannel } from '@/utils/project-types/project-type-guards';

const EmptyCast = () => {
  const sessionUuid = useAppSelector(selectFirstSessionUuid);
  const speakers = useSpeakersForSession({ sessionUuid });
  const userChannel = useAppSelector(selectUserChannel);
  const loadingSpeakers = useAppSelector(selectIsLoadingSpeakers);
  const channelIsWebinar = isWebinarChannel(userChannel?.type);

  const { dispatch: contextDispatch } = useCastAndCrewContext();

  if (speakers?.length && !loadingSpeakers) return null;
  return (
    <EmptyCastCrewShell
      loading={loadingSpeakers}
      title="Assemble the Cast"
      description={`Add speakers or presenters who will be featured in this ${channelIsWebinar ? 'webinar' : 'townhall'}.`}
    >
      <Button
        backgroundColor={getThemeColorCSSVariable()}
        hoverBackgroundColor={getThemeColorsCssMixVariable()}
        designSize="medium"
        onClick={() => {
          contextDispatch({ type: 'TOGGLE_ADD_CAST_AND_CREW_OPEN', payload: true });
        }}
      >
        <Text className="L2 flex ai-center gap-8" color={getThemeColorContrastCSSVariable()}>
          <Icon name={ICONS.ADD} size={12} /> <span>Add</span>
        </Text>
      </Button>
    </EmptyCastCrewShell>
  );
};

export default EmptyCast;
